module.exports = fox._r("images/ad-favorites.png", __webpack_public_path__ + "images/ad-favorites.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/ad-favorites.png
// module id = 965
// module chunks = 4